import { Outlet } from 'react-router-dom';

/**
 * Layout route wrapper (previously wrapped NuqsAdapter).
 * nuqs was removed — advanced table URL state now uses useSearchParams directly.
 * Kept as a pass-through to avoid changing the route tree structure.
 */
export function NuqsRouterAdapter() {
  return <Outlet />;
}
